import { render, staticRenderFns } from "./MainChart.vue?vue&type=template&id=3c3fdcfb&scoped=true&"
import script from "./MainChart.vue?vue&type=script&lang=js&"
export * from "./MainChart.vue?vue&type=script&lang=js&"
import style0 from "./MainChart.vue?vue&type=style&index=0&id=3c3fdcfb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3fdcfb",
  null
  
)

component.options.__file = "MainChart.vue"
export default component.exports